

function Services() {
    const servs = [
        "Framing", "Plumbing", "Electrical",
        "Drywall", "Tapping & Mudding",
        "Basement Updating", "Texture (popcorn) Ceiling",
        "Knockdown Ceiling", "Flooring", "Doors",
        "Windows", "Painting", "Washroom Updating",
        "Kitchen Cabinets"
    ];

    return (
        <div className="services-div">
            <h2 className="services-h2">Our Services:</h2>
            <ul className="services-ul">
                {servs.map((serv) => {
                    return <li key={serv}>{serv}</li>
                })}
            </ul>
        </div>
    );
}

export default Services;